import "./index.scss";

import React from "react";
import _ from "lodash";
import { toggleShow } from "Source/reducers/toast/toast.actions";
import { connect } from "react-redux";

@connect(store => {
    return {
        toast: store.toast
    };
})

class ToastContainer extends React.Component {
    constructor(props) {
        super(props);

        _.map([
            "handleClose",
        ], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    componentDidUpdate () {
        toastr.remove();
    }

    handleClose () {
        const { dispatch } = this.props;

        dispatch(toggleShow(false))
    }

    render() {
        const { toast } = this.props;
        const { component, show } = toast;
            
        if(show) {
            return <React.Fragment>
                {  React.cloneElement(component, { onClose: this.handleClose }) }
            </React.Fragment>       
        }

        return null;
    }
}

export default ToastContainer;